(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["barakka-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', (event) => {
  const opened = event.target;
  if (!(opened instanceof HTMLDetailsElement) || !opened.open || !opened.matches('.section-header details.mega-menu, .barakka-secondary--desktop details')) return;
  document.querySelectorAll('.section-header details.mega-menu[open], .barakka-secondary--desktop details[open]').forEach((other) => {
    if (other !== opened) {
      other.open = false;
      const summary = other.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
  });
}, true);
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.barakka-secondary details[open]').forEach((detail) => {
    detail.open = false;
    detail.querySelector('summary')?.focus();
  });
});
document.addEventListener('pointerdown', (event) => {
  document.querySelectorAll('.barakka-secondary--desktop details[open]').forEach((detail) => {
    if (!detail.contains(event.target)) detail.open = false;
  });
});
  } catch(e) { console.error(e); }
})();

})();
